import { render } from "./BasePassword.vue?vue&type=template&id=6f30c7c1"
import script from "./BasePassword.vue?vue&type=script&lang=js"
export * from "./BasePassword.vue?vue&type=script&lang=js"

import "../../assets/_form.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__